var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    {
      ref: "checkoutForm",
      attrs: { "lazy-validation": "" },
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.handleFormSubmit.apply(null, arguments)
        }
      },
      nativeOn: {
        keyup: function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          return _vm.submit($event)
        }
      },
      model: {
        value: _vm.valid,
        callback: function($$v) {
          _vm.valid = $$v
        },
        expression: "valid"
      }
    },
    [
      _c(
        "v-container",
        { staticClass: "checkout" },
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", sm6: "" } },
                [
                  _c("delivery-address", {
                    ref: "deliveryAddress",
                    attrs: { refs: _vm.refs, form: _vm.form },
                    on: { emailValidated: _vm.onEmailValidated }
                  }),
                  _c("delivery-methods", { attrs: { form: _vm.form } }),
                  _c("payment-methods", { attrs: { form: _vm.form } })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs12: "", sm6: "" } },
                [
                  _c("summary-block", { attrs: { form: _vm.form } }),
                  _c("place-order", {
                    attrs: { form: _vm.form, loading: _vm.loading },
                    on: { submit: _vm.submit }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }